export default __webpack_public_path__ + "static/media/Credit.1aa3e552.png";